/*import {
    repo_menu_icon_link,
} from '../../Utils'*/

export default function SidebarData(props) {
    let pathver = false
    try {
        if (props.rotas !== undefined)
            pathver = false
    } catch {
        pathver = true
    }

    return [

        // Painel Principal
        {
            id: '10',
            title: 'Painel Principal',
            title_lang: 'painel_principal',
            path: pathver ? ' ' : props.rotas.Main.view.endpoint,
            icon: 'house',
            cName: '',
            allow: false,
            show_submenu: false,
            submenu: []
        },

        // Corpotare
        {
            id: '11',
            title: 'Corporate',
            title_lang: 'corporate',
            path: pathver ? ' ' : props.rotas.Content_Corporate.view.endpoint,
            icon: 'info-circle',
            cName: '',
            allow: false,
            edit: false,
            view: true,
            show_submenu: false,
            submenu: []
        },

        // Os Meus Dados
        {
            id: '2002',
            title: 'Os meus dados',
            title_lang: 'my_data',
            path: pathver ? ' ' : props.rotas.Cliente.regist.endpoint,
            icon: 'person-badge',
            cName: '',
            allow: false,
            show_submenu: false,
            submenu: []
        },

        // Entidades
        {
            id: '3000',
            title: 'Entidades',
            title_lang: 'entidade',
            path: pathver ? '' : props.rotas.Entidade.list.endpoint,
            path_base: pathver ? '' : props.rotas.Entidade.base,
            icon: 'people-fill',
            cName: '',
            allow: false,
            module: 'Entidade',
            show_submenu: true,
            submenu: [
                {
                    id: '1017',
                    title: 'Lista de Clubes',
                    title_lang: 'lista_clubes',
                    path: pathver ? ' ' : props.rotas.Clube.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '3001',
                    title: 'Entidade interna',
                    title_lang: 'entidade_interna',
                    path: pathver ? '' : props.rotas.Entidade.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Entidade.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: [],

                    // Permite acessos
                    identificacao: false,
                    naturalidade: false,
                    fiscal: false,
                    contrato: false,
                    funcoes: false,
                    configuracoes: false,
                },
                {
                    id: '3002',
                    title: 'Entidade externa',
                    title_lang: 'entidade_externa',
                    path: pathver ? '' : props.rotas.Entidade_externa.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Entidade_externa.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: [],

                    // Permite acessos
                    identificacao: false,
                    naturalidade: false,
                    interlocutores: false,
                    fiscal: false,
                    associacao: false,
                    funcoes: false,
                    configuracoes: false,
                },

            ]
        },

        //Configurações
        {
            id: '5020',
            title: 'config',
            title_lang: 'config',
            path: pathver ? '' : props.rotas.Intranet_Department.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Department.base,
            icon: 'gear-wide-connected',
            cName: '',
            allow: false,
            module: 'intranet',
            show_submenu: true,
            submenu: [
                {
                    id: '5021',
                    title: 'Lista de Departamentos',
                    title_lang: 'intranet_department',
                    path: pathver ? '' : props.rotas.Intranet_Department.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Department.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '5022',
                    title: 'Lista de Grupos',
                    title_lang: 'intranet_groups',
                    path: pathver ? '' : props.rotas.Intranet_Groups.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Groups.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '1011',
                    title: 'Lista de Perfis de Utilizadores',
                    title_lang: 'lista_perfis_app',
                    path: pathver ? ' ' : props.rotas.AppPerfil.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '1012',
                    title: 'Lista de Tipos de Entidade',
                    title_lang: 'lista_perfis_empresa',
                    path: pathver ? ' ' : props.rotas.EntityPerfil.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '1013',
                    title: 'Lista de Funções',
                    title_lang: 'lista_entidade_funcoes',
                    path: pathver ? ' ' : props.rotas.Intranet_Entity_Function.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '1014',
                    title: 'Lista de Setores',
                    title_lang: 'lista_entidade_setores',
                    path: pathver ? ' ' : props.rotas.Intranet_Entity_Sector.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '1015',
                    title: 'Lista de Dimensões',
                    title_lang: 'lista_entidade_dimensoes',
                    path: pathver ? ' ' : props.rotas.Intranet_Entity_Dimension.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '1016',
                    title: 'Lista de Relações',
                    title_lang: 'lista_entidade_relacoes',
                    path: pathver ? ' ' : props.rotas.Intranet_Entity_Relation.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
            ]
        },

        // Notícias
        {
            id: '40',
            title: 'Notícias',
            title_lang: 'articles',
            path: pathver ? '' : props.rotas.Content_News.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_News.base,
            icon: 'newspaper',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            show_submenu: false,
            submenu: []
        },

        // SEPARADOR INTRANET
        {
            id: '1',
            title: 'SEPARADOR INTRANET',
            title_lang: 'separador_intranet',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider-title',
            allow: false,
            show_submenu: false,
            submenu: []
        },

        // Agenda
        {
            id: '17',
            title: 'Agenda',
            title_lang: 'agenda',
            path: pathver ? '' : props.rotas.Agenda.view.endpoint,
            path_base: pathver ? '' : props.rotas.Agenda.base,
            icon: 'calendar3',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Calendários
        {
            id: '16',
            title: 'Calendário',
            title_lang: 'calendar',
            path: pathver ? '' : props.rotas.CalendarCopy.view.endpoint,
            path_base: pathver ? '' : props.rotas.CalendarCopy.base,
            icon: 'calendar3',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Eventos
        {
            id: '18',
            title: 'Evento',
            title_lang: 'evento',
            path: pathver ? '' : props.rotas.Evento.list.endpoint,
            path_base: pathver ? '' : props.rotas.Evento.base,
            icon: 'calendar2-date',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Tarefa
        {
            id: '1830',
            title: 'Tarefa',
            title_lang: 'tarefa',
            path: pathver ? '' : props.rotas.Tarefa.list.endpoint,
            path_base: pathver ? '' : props.rotas.Tarefa.base,
            icon: 'list-task',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Suporte
        {
            id: '1850',
            title: 'Suporte',
            title_lang: 'suporte',
            path: pathver ? '' : props.rotas.Intranet_Suporte.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Suporte.base,
            icon: 'ticket-perforated',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Projetos
        {
            id: '1840',
            title: 'Projetos',
            title_lang: 'projetos',
            path: pathver ? '' : props.rotas.Intranet_Projetos.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Projetos.base,
            icon: 'qr-code',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        
        {
            id: '2001',
            title: 'Lista de Encomendas',
            title_lang: 'purchase_order',
            path: pathver ? ' ' : props.rotas.Intranet_PurchaseOrder.list.endpoint,
            icon: 'receipt',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        // CONFIG
        {
            id: '19',
            title: 'Configurações',
            title_lang: 'intranet_config',
            path: pathver ? '' : props.rotas.EventType.list.endpoint,
            path_base: pathver ? '' : props.rotas.EventType.base,
            icon: 'gear-wide-connected',
            cName: '',
            allow: false,
            module: 'intranet',
            show_submenu: true,
            submenu: [
                {
                    id: '20',
                    title: 'Tipo de Evento',
                    title_lang: 'event_type',
                    path: pathver ? '' : props.rotas.EventType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.EventType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
            ]
        },
        {
            id: '21',
            title: 'Licença',
            title_lang: 'license',
            path: pathver ? '' : props.rotas.Intranet_Geral_License.view.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Geral_License.view,
            icon: 'file-earmark-check',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // SEPARADOR COMPONENTES
        {
            id: '1200',
            title: 'SEPARADOR COMPONENTES',
            title_lang: 'separador_componentes',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider-title',
            allow: false,
            show_submenu: false,
            submenu: []
        },
        // Competicoes
        {
            id: '1851',
            title: 'Competições',
            title_lang: 'competicoes',
            path: pathver ? '' : props.rotas.Intranet_Competicoes.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Competicoes.base,
            icon: 'trophy',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Convocatorias
        {
            id: '1852',
            title: 'Convocatórias',
            title_lang: 'convocatorias',
            path: pathver ? '' : props.rotas.Intranet_Convocatorias.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Convocatorias.base,
            icon: 'ui-checks-grid',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        //Configurações
        {
            id: '5025',
            title: 'config',
            title_lang: 'config',
            path: pathver ? '' : props.rotas.Intranet_Temporadas.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Temporadas.base,
            icon: 'gear-wide-connected',
            cName: '',
            allow: false,
            module: 'intranet',
            show_submenu: true,
            submenu: [
                {
                    id: '5026',
                    title: 'Temporadas',
                    title_lang: 'temporadas',
                    path: pathver ? '' : props.rotas.Intranet_Temporadas.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Temporadas.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
            ]
        },

        // Selecoes
        { 
            id: '1853',
            title: 'Seleções',
            title_lang: 'selecoes',
            path: pathver ? '' : props.rotas.Intranet_Selecoes.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Selecoes.base,
            icon: 'person-lines-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },


        // SEPARADOR QUALIDADE
        {
            id: '120',
            title: 'SEPARADOR QUALIDADE',
            title_lang: 'separador_quality',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider-title',
            allow: false,
            show_submenu: false,
            submenu: []
        },
        {
            id: '156',
            title: 'Avaliação de Fornecedores',
            title_lang: 'intranet_quality_supplier_evaluation',
            path: pathver ? '' : props.rotas.Intranet_Quality_SupplierEvaluation.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_SupplierEvaluation.base,
            icon: 'people-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '200',
            title: 'EPI',
            title_lang: 'intranet__quality_epi_create',
            path: pathver ? '' : props.rotas.Intranet_Quality_EPI.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_EPI.base,
            icon: 'shield-check',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '202',
            title: 'Acompanhamento',
            title_lang: 'intranet__quality_acompanhamento',
            path: pathver ? '' : props.rotas.Intranet_Quality_Acompanhamento.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_Acompanhamento.base,
            icon: 'caret-right-square',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '121',
            title: 'Gestão Documental',
            title_lang: 'intranet_quality_document',
            path: pathver ? '' : props.rotas.Intranet_Quality_Document.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_Document.base,
            icon: 'file-earmark-check',
            cName: '',
            allow: false,
            module: 'website',
            separator: 'next',
            show_submenu: true,
            submenu: [
                {
                    id: '161',
                    title: 'Documentos',
                    title_lang: 'intranet_quality_document',
                    path: pathver ? '' : props.rotas.Intranet_Quality_Document.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_Document.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '162',
                    title: 'Documentos Obsoletos',
                    title_lang: 'intranet_quality_document_obsolete',
                    path: pathver ? '' : props.rotas.Intranet_Quality_DocumentObsolete.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_DocumentObsolete.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    view: true,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '163',
                    title: 'Documentos Apagados',
                    title_lang: 'intranet_quality_document_deleted',
                    path: pathver ? '' : props.rotas.Intranet_Quality_DocumentDeleted.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_DocumentDeleted.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    view: true,
                    show_submenu: false,
                    submenu: []
                },
            ]
        },
        {
            id: '126',
            title: 'Ocorrência',
            title_lang: 'intranet_quality_occurrence',
            path: pathver ? '' : props.rotas.Intranet_Quality_Occurrence.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_Occurrence.base,
            icon: 'clipboard2-x',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '151',
            title: 'Apostas / Riscos',
            title_lang: 'intranet_quality_strategybetsrisks',
            path: pathver ? '' : props.rotas.Intranet_Quality_StrategyBetsRisks.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_StrategyBetsRisks.base,
            icon: 'clipboard2-pulse',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '152',
            title: 'Acompanhamento e Monitorização',
            title_lang: 'intranet_quality_monitoring_indicators',
            path: pathver ? '' : props.rotas.Intranet_Quality_MonitoringIndicators.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_MonitoringIndicators.base,
            icon: 'clipboard2-pulse',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '155',
            title: 'Formação',
            title_lang: 'intranet_quality_formation',
            path: pathver ? '' : props.rotas.Intranet_Quality_Formation.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_Formation.base,
            icon: 'people-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // Froms
        {
            id: '23',
            title: 'Forms',
            title_lang: 'forms',
            path: pathver ? '' : props.rotas.Forms.list.endpoint,
            path_base: pathver ? '' : props.rotas.Forms.base,
            icon: 'sliders',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '150',
            title: 'Planeamento Estratégico',
            title_lang: 'intranet_quality_strategy',
            path: pathver ? '' : props.rotas.Intranet_Quality_Strategy.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_Strategy.base,
            icon: 'clipboard2-pulse',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // QUALIDADE
        {
            id: '122',
            title: 'Configurações',
            title_lang: 'intranet_config',
            path: pathver ? '' : props.rotas.Intranet_Quality_DocumentType.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_DocumentType.base,
            icon: 'gear-wide-connected',
            cName: '',
            allow: false,
            module: 'intranet',
            show_submenu: true,
            submenu: [
                {
                    id: '123',
                    title: 'Tipos de Documentos',
                    title_lang: 'intranet_quality_document_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_DocumentType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_DocumentType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '124',
                    title: 'Tipos de Tempo de Retenção',
                    title_lang: 'intranet_quality_retention_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_RetentionTime.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_RetentionTime.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '125',
                    title: 'Tipos de Armazenamento',
                    title_lang: 'intranet_quality_storage_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_StorageType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_StorageType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '127',
                    title: 'Tipos de Ocorrências',
                    title_lang: 'intranet_quality_occurrence_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_OccurrenceType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_OccurrenceType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '128',
                    title: 'Origens de Ocorrências',
                    title_lang: 'intranet_quality_occurrence_origin',
                    path: pathver ? '' : props.rotas.Intranet_Quality_OccurrenceOrigin.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_OccurrenceOrigin.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '129',
                    title: 'Estado de Ocorrências',
                    title_lang: 'intranet_quality_occurrence_state',
                    path: pathver ? '' : props.rotas.Intranet_Quality_OccurrenceState.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_OccurrenceState.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '170',
                    title: 'Critério Avaliação Fornecimento',
                    title_lang: 'intranet_quality_supplier_evaluation_criterion',
                    path: pathver ? '' : props.rotas.Intranet_Quality_SupplierEvaluationType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_SupplierEvaluationType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: true,
                    edit: true,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '171',
                    title: 'Avaliação de Fornecimento',
                    title_lang: 'intranet_quality_supply_quality_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_SupplyQualityType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_SupplyQualityType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: true,
                    edit: true,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '172',
                    title: 'Avaliação de Fornecedor',
                    title_lang: 'intranet_quality_supplier_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_SupplierQualityType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_SupplierQualityType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: true,
                    edit: true,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '173',
                    title: 'Tipo Fornecimento',
                    title_lang: 'intranet_quality_supply_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_SupplyType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_SupplyType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: true,
                    edit: true,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '24',
                    title: 'Tipo de Formulário',
                    title_lang: 'forms_type',
                    path: pathver ? '' : props.rotas.FormsType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.FormsType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '174',
                    title: 'Tipo Avaliação de Formações',
                    title_lang: 'intranet_quality_formation_classification_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_FormationClassificationType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_FormationClassificationType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: true,
                    edit: true,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '175',
                    title: 'Tipo Estado de Formações',
                    title_lang: 'intranet_quality_formation_state_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_FormationStateType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_FormationStateType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: true,
                    edit: true,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '201',
                    title: 'Tipos de EPI',
                    title_lang: 'intranet_quality_epi_stage_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_EPI_Type.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_EPI_Type.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '204',
                    title: 'Tipos de Acompanhamento',
                    title_lang: 'intranet_quality_acompanhamento_type',
                    path: pathver ? '' : props.rotas.Intranet_Quality_Acompanhamento_Type.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Quality_Acompanhamento_Type.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
            ]
        },
        {
            id: '153',
            title: 'Licença',
            title_lang: 'license',
            path: pathver ? '' : props.rotas.Intranet_Quality_License.view.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Quality_License.view,
            icon: 'file-earmark-check',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // SEPARADOR CRM    
        {
            id: '180',
            title: 'SEPARADOR CRM',
            title_lang: 'separador_crm',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider-title',
            allow: false,
            show_submenu: false,
            submenu: []
        },

        // Contactos
        {
            id: '3010',
            title: 'Contactos',
            title_lang: 'contact',
            path: pathver ? '' : props.rotas.Contact.list.endpoint,
            path_base: pathver ? '' : props.rotas.Contact.base,
            icon: 'signpost-split-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        // Oportunidade
        {
            id: '181',
            title: 'Oportunidade',
            title_lang: 'intranet_crm_opportunity',
            path: pathver ? '' : props.rotas.Intranet_CRM_Opportunity.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_CRM_Opportunity.base,
            icon: 'signpost-split-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        {
            id: '182',
            title: 'Configurações',
            title_lang: 'intranet_config',
            path: pathver ? '' : props.rotas.Intranet_CRM_StageType.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_CRM_StageType.base,
            icon: 'gear-wide-connected',
            cName: '',
            allow: false,
            module: 'intranet',
            show_submenu: true,
            submenu: [
                {
                    id: '183',
                    title: 'Tipos de Estado',
                    title_lang: 'intranet_crm_stage_type',
                    path: pathver ? '' : props.rotas.Intranet_CRM_StageType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_CRM_StageType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '184',
                    title: 'Tipos de Comunicação',
                    title_lang: 'intranet_crm_comtype',
                    path: pathver ? '' : props.rotas.Intranet_CRM_ComType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_CRM_ComType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
            ]
        },
        {
            id: '179',
            title: 'Licença',
            title_lang: 'license',
            path: pathver ? '' : props.rotas.Intranet_CRM_License.view.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_CRM_License.view,
            icon: 'file-earmark-check',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        // SEPARADOR MANUTENÇÃO
        {
            id: '130',
            title: 'SEPARADOR MANUTENÇÃO',
            title_lang: 'separador_maintenance',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider-title',
            allow: false,
            show_submenu: false,
            submenu: []
        },
        // Ativos
        {
            id: '131',
            title: 'Ativos',
            title_lang: 'intranet_maintenance_active',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Active.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Active.base,
            icon: 'x-diamond-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        // Reparação
        {
            id: '135',
            title: 'Reparação',
            title_lang: 'intranet_maintenance_repair',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Repair.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Repair.base,
            icon: 'heart-pulse-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        {
            id: '137',
            title: 'Ordens de Manutenção',
            title_lang: 'intranet_maintenance_orders',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Orders.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Orders.base,
            icon: 'file-earmark-medical-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        {
            id: '138',
            title: 'Planeamento',
            title_lang: 'intranet_maintenance_planeamento',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Planeamento.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Planeamento.base,
            icon: 'x-diamond-fill',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        {
            id: '140',
            title: 'Registo de Intervenção',
            title_lang: 'intranet_maintenance_intervention',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Intervention.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Intervention.base,
            icon: 'stop-circle',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        {
            id: '143',
            title: 'Custos de Manutenção',
            title_lang: 'intranet_maintenance_cost',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Cost.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Cost.base,
            icon: 'receipt-cutoff',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },

        {
            id: '144',
            title: 'Gestão de Energia',
            title_lang: 'intranet_maintenance_energy',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_Energy.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Energy.base,
            icon: 'battery-charging',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            dash: false,
            admin: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        // MANUTENCAO CONFIG
        {
            id: '132',
            title: 'Configurações',
            title_lang: 'intranet_config',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_ActiveType.list.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_ActiveType.base,
            icon: 'gear-wide-connected',
            cName: '',
            allow: false,
            module: 'intranet',
            show_submenu: true,
            submenu: [
                {
                    id: '133',
                    title: 'Tipos de Ativos',
                    title_lang: 'intranet_maintenance_active_type',
                    path: pathver ? '' : props.rotas.Intranet_Maintenance_ActiveType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Maintenance_ActiveType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '134',
                    title: 'Tipos de Estados do Ativo',
                    title_lang: 'intranet_maintenance_active_state',
                    path: pathver ? '' : props.rotas.Intranet_Maintenance_ActiveState.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Maintenance_ActiveState.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '136',
                    title: 'Tipos de reparação',
                    title_lang: 'intranet_maintenance_repair_type',
                    path: pathver ? '' : props.rotas.Intranet_Maintenance_RepairType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Maintenance_RepairType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '139',
                    title: 'Periodicidade',
                    title_lang: 'intranet_maintenance_periodicity',
                    path: pathver ? '' : props.rotas.Intranet_Maintenance_Periodicity.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Periodicity.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '141',
                    title: 'Prioridade',
                    title_lang: 'intranet_maintenance_priority',
                    path: pathver ? '' : props.rotas.Intranet_Maintenance_Priority.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Maintenance_Priority.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },
                {
                    id: '142',
                    title: 'Tipo de Energia',
                    title_lang: 'intranet_maintenance_energy_type',
                    path: pathver ? '' : props.rotas.Intranet_Maintenance_EnergyType.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Intranet_Maintenance_EnergyType.base,
                    icon: '',
                    cName: '',
                    allow: false,
                    create: false,
                    edit: false,
                    view: true,
                    remove: false,
                    show_submenu: false,
                    submenu: []
                },

            ]
        },
        {
            id: '154',
            title: 'Licença',
            title_lang: 'license',
            path: pathver ? '' : props.rotas.Intranet_Maintenance_License.view.endpoint,
            path_base: pathver ? '' : props.rotas.Intranet_Maintenance_License.view,
            icon: 'file-earmark-check',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            module: 'website',
            separator: 'next',
            show_submenu: false,
            submenu: []
        },
        // SEPARADOR OUTROS
        {
            id: '2',
            title: 'SEPARADOR OUTROS',
            title_lang: 'separador_outros',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider-title',
            allow: false,
            show_submenu: false,
            submenu: []
        },

        // Menus
        {
            id: '1030',
            title: 'Menus',
            title_lang: 'menus',
            path: pathver ? '' : props.rotas.Structure.list.endpoint,
            path_base: pathver ? '' : props.rotas.Structure.base,
            icon: 'diagram-3',
            cName: '',
            allow: false,
            create: false,
            edit: false,
            view: true,
            remove: false,
            module: 'website',
            show_submenu: false,
            submenu: []
        },

    ]

}